import { useEffect, useId, useState } from 'react';
import { type AiBuilderProgressMessage } from '../store';
import { AiBuilderAssistantMessageSlot } from './AiBuilderAssistantMessageSlot';
import { AiBuilderProgressStepList } from './AiBuilderProgressStepList';
import { AiBuilderProgressTitle } from './AiBuilderProgressTitle';
import { AiBuilderThinkingStream } from './AiBuilderThinkingStream';

// 하위 호환 재수출 — canonical 위치는 store/types (메시지 도메인 타입).
export type { AiBuilderProgressMessage, AiBuilderProgressMessageStatus } from '../store';

/** progress 메시지 → 상태별 타이틀/스텝 조립 어댑터. UI 조각은 Title/StepList 참고. */
export const AiBuilderProgressMessageContent = ({
  message
}: {
  message: AiBuilderProgressMessage;
}) => {
  const detailsId = useId();
  const hasSteps = message.steps.length > 0;
  const isRunning = message.status === 'running';
  const thinkingText = message.thinkingText;
  const canToggleDetails = !isRunning && hasSteps;
  const [collapsed, setCollapsed] = useState(() => canToggleDetails);
  const showThinkingText = !!thinkingText && (isRunning || !collapsed);
  useEffect(() => {
    setCollapsed(canToggleDetails);
  }, [canToggleDetails, message.id, message.status]);
  return <AiBuilderAssistantMessageSlot role="status" aria-live="polite" className="flex-col items-start" variant="progress" data-ai-assistant-progress-slot data-sentry-element="AiBuilderAssistantMessageSlot" data-sentry-component="AiBuilderProgressMessageContent" data-sentry-source-file="AiBuilderProgressMessageContent.tsx">
      {isRunning ? <AiBuilderProgressTitle.Running>
          {message.title}
        </AiBuilderProgressTitle.Running> : canToggleDetails ? <AiBuilderProgressTitle.Toggle ariaControls={detailsId} collapsed={collapsed} onToggle={() => setCollapsed(prev => !prev)}>
          {message.title}
        </AiBuilderProgressTitle.Toggle> : <AiBuilderProgressTitle.Static>
          {message.title}
        </AiBuilderProgressTitle.Static>}

      {showThinkingText ? <AiBuilderThinkingStream text={thinkingText} enabled={isRunning} /> : null}

      {hasSteps && (isRunning || !collapsed) ? <AiBuilderProgressStepList id={detailsId} status={message.status} steps={message.steps} /> : null}
    </AiBuilderAssistantMessageSlot>;
};